import { Component } from 'react';

import Modal from 'components/common/Modal/Modal';
import { Button, BUTTON } from 'components/common/Button/Button';
const { SIZE, COLOR, BGCOLOR } = BUTTON;

import styles from './SelectionModal.scss';

class SelectionModal extends Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            selectedOption: null,
        };
    }

    componentDidMount() {
        const { options } = this.props;
        const firstEnabledOption = options.find(option => option.enabled);

        if (firstEnabledOption) {
            this.setState({ selectedOption: firstEnabledOption.value });
        }
    }

    onChange(event) {
        this.setState({ selectedOption: event.target.value });
    }

    onSubmit() {
        this.props.onSubmit(this.state.selectedOption);

        this.setState({ selectedOption: null });
    }

    onClose() {
        this.setState({
            selectedOption: null,
        });

        this.props.onClose();
    }

    createOption(option) {
        const { value, label, enabled } = option;
        const optionId = `event-types-input-option-${value}`;
        const labelClassName = enabled ? '' : styles.disabledInputOption;

        return (
            <div key={`${optionId}-option`} className={styles.inputOption} data-cy="SelectionModal-createOption">
                <input
                    id={optionId}
                    value={value}
                    defaultChecked = {value === this.state.selectedOption}
                    type="radio"
                    name="eventType"
                    disabled={!enabled}
                    data-cy="SelectionModal-input"
                />
                <label className={labelClassName} htmlFor={optionId} data-cy="SelectionModal-label">{label}</label>
            </div>
        );
    }

    createInputFields(options) {
        const id = 'event-types-input-options';
        return (
            <div key={id} id={id} onChange={this.onChange} data-cy="SelectionModal-onChange">
                <h3 className={styles.title}>Select an Event Type</h3>
                { options.map(option => {
                    return this.createOption(option);
                })}
            </div>
        );
    }

    renderOptions() {
        return (
            <div className={styles.actionButtons} data-cy="SelectionModal-renderOptions">
                <Button
                    text={'Export PDF'}
                    type={SIZE.PRIMARY}
                    color={COLOR.WHITE}
                    bgcolor={BGCOLOR.ORANGE}
                    onClick={this.onSubmit}
                    data-cy="SelectionModal-onClick"
                />
            </div>
        );
    }

    render() {
        const { options } = this.props;

        return (
            <div id="event-types-modal-main" data-cy="SelectionModal-render">
                <Modal ref="eventTypesModal" title={'Export Events'} open={true} 
                    onClose={this.onClose} data-cy="SelectionModal-onClose">
                    <div id="event-types-modal-content" data-cy="SelectionModal-onClose">
                        { this.createInputFields(options) }

                        { this.renderOptions() }
                    </div>
                </Modal>
            </div>
        );
    }
}

export default SelectionModal;
